export const parseJSON = (/** @type {Response} */ response: Response) => {
  return response.text().then((text) => {
    try {
      return JSON.parse(text);
    } catch (e) {
      console.error('Failed to parse JSON:', e);
      return null;
    }
  });
};
